import { ILoanQuote } from '@/app/models/loanQuote'
import { isNewLoan } from '@/app/stores/loan/loan-comparator.store'
import {
    SCREEN_CONTACT,
    SCREEN_INSURANCE,
    SCREEN_LOAN,
    SCREEN_PROFILE_CO,
    SCREEN_PROFILE_MAIN,
    SCREEN_PROJECT,
    screenToVisibleStep,
} from '@/app/components/loanComparator/loan-quotation-steps.constants'

// Valeurs de project_type de l'onglet « Variables » du plan de marquage.
const PROJECT_TYPE_SEARCH = 'recherche assurance'
const PROJECT_TYPE_SWITCH = 'changement assurance'
const PROJECT_TYPE_REPURCHASE = 'rachat crédit'

// Libellés découplés du fil d'Ariane : les wordings d'interface changent, la série analytics non.
const SCREEN_STEP_NAMES: Record<number, string> = {
    [SCREEN_PROJECT]: 'type de projet',
    [SCREEN_PROFILE_MAIN]: 'profil emprunteur',
    [SCREEN_PROFILE_CO]: 'profil co-emprunteur',
    [SCREEN_LOAN]: 'caracteristiques emprunt',
    [SCREEN_INSURANCE]: 'assurance',
    [SCREEN_CONTACT]: 'coordonnees',
}

// Dérivé de type_quote, la vérité serveur : project_progression n'existe que côté client et ne survit pas au refresh.
export const buildAeParams = (quote: ILoanQuote | null): Record<string, string> => {
    if (!quote?.type_quote) return {}
    if (quote.is_loan_repurchase) return { project_type: PROJECT_TYPE_REPURCHASE }
    return { project_type: isNewLoan(quote) ? PROJECT_TYPE_SEARCH : PROJECT_TYPE_SWITCH }
}

export const buildAeStepParams = (screen: number): Record<string, string> => ({
    form_step_name: SCREEN_STEP_NAMES[screen] ?? '',
    form_step_number: `step ${screenToVisibleStep(screen)}`,
})
